<div class="spinner-overlay" *ngIf="isLoading">
  <nz-spin nzSpinning="true" nzSize="large">
    <div class="spinner-content">Loading...</div>
  </nz-spin>
</div>

<div class="create-collaboration-wrapper">
  <h2 class="nfl-form-label mb1" nz-typography>Create Collaboration</h2>
  <nz-layout>
    <app-collaboration-stepper [currentStep]="currentStep"></app-collaboration-stepper>
    <nz-content class="content">
      <nz-card class="collaboration-form-card">
        <app-collaboration-details
          *ngIf="currentStep === 0"
          #collaborationDetailsComponent
          (nextStep)="onCollaborationDetailsNext()"
          (cancel)="onCollaborationDetailsCancel()"
        ></app-collaboration-details>

        <app-collaboration-dataset
          *ngIf="currentStep === 1"
          #collaborationDatasetComponent
          (nextStep)="onDatasetNext()"
          (previousStep)="onDatasetBack()"
          (cancel)="onDatasetCancel()"
        ></app-collaboration-dataset>

        <app-collaboration-invitation
          *ngIf="currentStep === 2"
          #collaborationInvitationComponent
          (nextStep)="onInvitationNext()"
          (cancelBtn)="onInvitationCancel()"
        ></app-collaboration-invitation>

        <app-collaboration-summary
          *ngIf="currentStep === 3"
          #collaborationSummaryComponent
          (editSection)="onSummaryEditSection($event)"
        ></app-collaboration-summary>

        <nz-divider></nz-divider>
        <div class="button-container">
          <button nz-button nzType="default" (click)="onCancel()" [disabled]="isLoading">
            {{ currentStep > 0 ? 'Back' : 'Cancel' }}
          </button>
          <div>
            <button
              *ngIf="currentStep !== 3"
              nz-button
              nzType="default"
              (click)="onSaveAsDraft()"
              [disabled]="!isValidAction() || isLoading"
              [nzLoading]="isLoading"
            >
              Save As Draft
            </button>

            <button nz-button nzType="primary" (click)="onNext()" [disabled]="!canNext()" [nzLoading]="isLoading">
              {{ currentStep === 3 ? 'Send Invites' : 'Next' }}
            </button>
          </div>
        </div>
      </nz-card>
    </nz-content>
  </nz-layout>
</div>
